var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassBreakDetector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 6.7,
    cy: 8,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.2,
    y1: 15.5,
    x2: 11.8,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.2,
    y1: 0.5,
    x2: 11.8,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.5,
    y1: 15.5,
    x2: 9.5,
    y2: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassBreakDetector);
export default __webpack_public_path__ + "static/media/GlassBreakDetector.261747a201d024a8268734b817fdf9dc.svg";
export { ForwardRef as ReactComponent };